import { render } from "./PostHocPowerAnalysis.vue?vue&type=template&id=13dc7c03&scoped=true"
import script from "./PostHocPowerAnalysis.vue?vue&type=script&lang=js"
export * from "./PostHocPowerAnalysis.vue?vue&type=script&lang=js"

import "./PostHocPowerAnalysis.vue?vue&type=style&index=0&id=13dc7c03&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13dc7c03"]])

export default __exports__